import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const getTicketStats = createAsyncThunk(
  'ticketStats/getTicketStats',
  async ({ group_id } = {}, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      const params = {};
      if (group_id) params.group_id = group_id;

      const response = await axios.get(
        `${ROOT_URL}/ticket/stats/${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          },
          params,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  stats: null,
  lastFetchedGroupId: null,
};

const getTicketStatsSlice = createSlice({
  name: 'getTicketStats',
  initialState,
  reducers: {
    resetTicketStatsState: (state) => {
      state.loading = false;
      state.error = null;
      state.stats = null;
      state.lastFetchedGroupId = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketStats.pending, (state, action) => {
        const groupId = action.meta?.arg?.group_id ?? null;
        const sameGroup =
          state.lastFetchedGroupId != null &&
          String(state.lastFetchedGroupId) === String(groupId);
        state.loading = !(state.stats != null && sameGroup);
        state.error = null;
      })
      .addCase(getTicketStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload.data;
        state.lastFetchedGroupId = action.meta?.arg?.group_id ?? null;
        state.error = null;
      })
      .addCase(getTicketStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.stats = null;
      });
  }
});

export const { resetTicketStatsState } = getTicketStatsSlice.actions;
export default getTicketStatsSlice.reducer;
